import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg, homeFor } from "@/lib/api";

export default function AuthCallback() {
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(window.location.hash.slice(1)).get("session_id");
    window.history.replaceState(null, "", window.location.pathname);
    api
      .post("/auth/google/session", { session_id: sessionId })
      .then(({ data }) => {
        setUser(data);
        navigate(homeFor(data), { replace: true });
      })
      .catch((e) => {
        toast.error(errMsg(e, "Login Google gagal"));
        setUser(false);
        navigate("/masuk", { replace: true });
      });
  }, [navigate, setUser]);

  return <div className="min-h-screen bg-stone-50" data-testid="auth-callback" />;
}
